// Pin a calendar day to 12:00 UTC so it reads as the same day in any US timezone
const toNoonUTC = (value) => {
    const d = value ? new Date(value) : new Date();
    if (isNaN(d)) return value;
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12)).toISOString();
}

const dateFields = ['eventData_startDate', 'eventData_endDate', 'eventData_endSaleDate'];

const toEventData = (product, id) => {
    const event = {
        name: id === 'new' ? '' : product.name,
        sku: product.sku,
        price: product.price,
        description: id === 'new' ? '' : product.description,
        inventory_level: product.inventory_level,
        eventData_startDate: toNoonUTC(),
        eventData_endDate: toNoonUTC(),
        eventData_endSaleDate: toNoonUTC(),
    };

    product.custom_fields.forEach(field => {
        if (field.name.includes('eventData_')) {
            event[`${field.name}`] = dateFields.includes(field.name) ? toNoonUTC(field.value) : field.value;
        }
    });

    return event;
}

const options = {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  }

const toProductData = (id, formData, initial) => {
    const product = {...initial};

    if (id === 'new') {
        product.custom_fields.forEach(field => {
            delete field.id;
        });
        delete product.id;
        delete product.created;
        delete product.custom_url
        product.is_visible = true;
        product.availability = 'available';
        product.images.forEach(image => {
            delete image.id;
            delete image.date_modified;
            delete image.product_id;
            image.image_url = image.url_standard;
        });
        if (formData.get('name').includes('NEW')) {
            const findMaterial = product.custom_fields.find(f => f.name === 'Material Number - NEW')
            if (findMaterial) {
                product.custom_fields.push({
                    name: 'SAP Material',
                    value: findMaterial.value,
                });
            }
        }
        else if (formData.get('name').includes('RECERT')) {
            const findMaterial = product.custom_fields.find(f => f.name === 'Material Number - RECERT')
            if (findMaterial) {
                product.custom_fields.push({
                    name: 'SAP Material',
                    value: findMaterial.value,
                });
            }
        }
    }

    let dateString = {}
    let locationString = {}
    let timeZone, endSaleDate, endSaleTime

    formData.forEach((value, key) => {
        if (key.includes('eventData_')) {
            if (value !== '' && value !== 'undefined' && value !== null && value !== undefined ) {
                const cf = {
                    name: key,
                    value: value,
                };
    
                if (initial) {
                    const getIndex = initial.custom_fields.findIndex(f => f.name === key);
                    if (getIndex > -1) {
                        product.custom_fields[getIndex] = {
                            ...product.custom_fields[getIndex],
                            value: value,
                        };
                    }
                    else product.custom_fields.push(cf);
                }
                else product.custom_fields.push(cf);

                if (key === 'eventData_startDate') {
                    dateString.start = `${new Date(value).toLocaleDateString('en-US', options)}`;
                }

                if (key === 'eventData_endDate') {
                    dateString.end = `${new Date(value).toLocaleDateString('en-US', options)}`;
                }

                if (key === 'eventData_startTime') {
                    dateString.startTime = ` @ ${convertTo12Hour(value)}`;
                }

                if (key === 'eventData_endTime') {
                    dateString.endTime = ` @ ${convertTo12Hour(value)}`;
                }

                if (key === 'eventData_timezone') {
                    dateString.timezone = ` ${value}`;
                    timeZone = value;
                }

                if (key === 'eventData_venueName') {
                    locationString.name = value;
                }

                if (key === 'eventData_endSaleDate' ) {
                    endSaleDate = value;
                }

                if (key === 'eventData_endSaleTime') {
                    endSaleTime = value;
                }

            }
        }
        else if (key === 'inventory_level') {
            product[key] = parseInt(value);
        }
        else {
            product[key] = value;
        }
    });

    const addr = product.custom_fields.findIndex(field => field.name === 'eventData_formattedAddress');

    if (addr > -1) {
        locationString.location = product.custom_fields[addr].value;
    }

    // delete text after | in product name
    const splitName = product.name.split('|');
    let newName = ''

    if (splitName[splitName.length - 1].includes('@')) {
        splitName.pop();
    }

    newName = splitName.join('|');

    product.name = newName + ` | ${dateString.start}${dateString.startTime} - ${dateString.end}${dateString.endTime}${dateString.timezone}`
    product.preorder_message = `${locationString.name} | ${locationString.location}`

    if (endSaleDate) {
        const eventEndDay =  endSaleDate.split('T')[0];
        const eventEndTime = endSaleTime ? endSaleTime : '11:59';
        const eventEndTimeZone = timeZone ? timeZone : 'EDT';
        const eventEndDate = new Date(`${eventEndDay}T${eventEndTime}:00${timeZoneOffset[eventEndTimeZone]}`).getTime();
        
        const now = new Date();
        const utcTimestamp = now.getTime() - (now.getTimezoneOffset() * 60000);
        const offset = (timeZoneOffsetInt[eventEndTimeZone] * 60);
        const offsetTimestamp = utcTimestamp + (offset * 60000);
        const dateWithOffset = new Date(offsetTimestamp).getTime();

        if (eventEndDate >= now.getTime()) {
            product.availability = 'available';
        }
        else {
            product.availability = 'disabled';
        }
    }

    return product;
}

export {
    toEventData,
    toProductData,
    toNoonUTC,
}

const convertTo12Hour = (time) => {
    let [hours, minutes] = time.split(':');
    let period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${period}`;
}

const timeZoneOffsetInt = {
    'EST': 5,
    'EDT': 4,
    'CST': 6,
    'CDT': 5,
    'MST': 7,
    'MDT': 6,
    'PST': 8,
    'PDT': 7,
    'AKST': 9,
    'AKDT': 8,
    'HST': 10,
    'HDT': 9
}

const timeZoneOffset = {
    'EST': '-05:00',
    'EDT': '-04:00',
    'CST': '-06:00',
    'CDT': '-05:00',
    'MST': '-07:00',
    'MDT': '-06:00',
    'PST': '-08:00',
    'PDT': '-07:00',
    'AKST': '-09:00',
    'AKDT': '-08:00',
    'HST': '-10:00',
    'HDT': '-09:00'
}
